import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-aside-page-footer',
  templateUrl: './aside-page-footer.component.html',
  styleUrls: ['./aside-page-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsidePageFooterComponent {}
